export default __webpack_public_path__ + "static/eneAcademyHeroDevelop-894ab0a8fa7be266bc3f5181df4fad58.png";